import React, { useEffect, useState } from "react";
import cardType from "../../assets/creditCard.svg";
import chip from "../../assets/Chip.svg";
import connectIcon from "../../assets/Conection Icon.svg";
import creditCard from "../../assets/creditCard.svg";
// import connectIcon from "../../assets/Conection Icon.svg";
import { load } from "@cashfreepayments/cashfree-js";
import "./Card.css";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import amex from "../../assets/cardLogo/amex.png";
import master from "../../assets/cardLogo/master.png";
import rupay from "../../assets/cardLogo/rupay.png";
import visa from "../../assets/cardLogo/visa.png";
import axios from "axios";
import { initiateCard } from "./easebuzz";
function Card({
  finalAmountWithMDR,
  childComponentFunctionRef,
  paymentId,
  payRef,
  collect_request_id,
  cardType,
  isBlank,
  isEasebuzzSchool,
  easebuzzPaymentId,
  setOpenWindow,
}) {
  const [isFlipped, setIsFlipped] = useState(false);
  const { sessionId } = useParams();

  const [cashfree, setCashfree] = useState(null); // State to store Cashfree instance
  const [cardComponent, setCardComponent] = useState(null);
  const [isCardNumberReady, setIsCardNumberReady] = useState(false);
  const [isCardCvvReady, setIsCardCvvReady] = useState(false);
  const [isCardExpiryReady, setIsCardExpiryReady] = useState(false);
  const [isCardHolderReady, setIsCardHolderReady] = useState(false);

  const [cardHolderName, setCardHolderName] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [cardCvvNumber, setCardCvvNumber] = useState("");
  const [cardExpiryDate, setCardExpiryDate] = useState("");
  const [card_type, set_card_type] = useState({
    type: "",
    img: "",
  });

  let cvvComponent;

  const mountingCardNumber = () => {
    let card = cashfree.create("cardNumber", {
      values: {
        placeholder: "enter card number",
      },
      classes: {
        base: "my-base",
        complete: "my-complete",
      },
      style: {
        base: {
          color: "#FFFFFF",
          fontSize: "12px",
        },
      },
    });
    setCardComponent(card);
    card.on("loaderror", function (data) {});
    card.mount("#cardNumber");
    card.on("change", function (data) {
      cvvComponent.update({ cvvLength: data.value.cvvLength });
      if (card.isComplete()) setIsCardNumberReady(true);
      else setIsCardNumberReady(false);
    });
    card.on("complete", function (d) {
      const finalAmount = finalAmountWithMDR(cardType, d.value.brand);
    });
  };
  const mountingCardHolder = () => {
    let cardHolder = cashfree.create("cardHolder", {
      values: {
        placeholder: "enter card holder name",
        cardHolder: "",
      },
      classes: {
        base: "my-base",
        complete: "my-complete",
      },
      style: {
        base: {
          color: "#FFFFFF",
          fontSize: "12px",
        },
      },
    });
    cardHolder.on("loaderror", function (data) {});
    cardHolder.mount("#cardHolder");

    cardHolder.on("change", function () {
      if (cardHolder.isComplete()) setIsCardHolderReady(true);
      else setIsCardHolderReady(false);
    });
  };
  const mountingExpiryDate = () => {
    let cardExpiry = cashfree.create("cardExpiry", {
      classes: {
        base: "my-expiry",
        complete: "my-expiry-complete",
      },
      style: {
        base: {
          color: "#fff",
          fontSize: "12px",
        },
      },
    });
    cardExpiry.on("loaderror", function (data) {});
    cardExpiry.mount("#expiry");

    cardExpiry.on("change", function () {
      if (cardExpiry.isComplete()) setIsCardExpiryReady(true);
      else setIsCardExpiryReady(false);
    });
  };
  const mountingCvv = () => {
    cvvComponent = cashfree.create("cardCvv", {
      values: {
        placeholder: "enter card cvv",
      },
      style: {
        base: {
          textAlign: "right",
          color: "#fff",
          fontSize: "12px",
        },
      },
    });
    cvvComponent.on("loaderror", function (data) {});
    cvvComponent.mount("#cvv");

    cvvComponent.on("change", function () {
      if (cvvComponent.isComplete()) setIsCardCvvReady(true);
      else setIsCardCvvReady(false);
    });
  };
  useEffect(() => {
    if (isEasebuzzSchool === false) {
      payRef.current.disabled = true;
      const loadCashfree = async () => {
        const cf = await load({ mode: process.env.REACT_APP_CASHFREE_MODE }); // Change to 'production' for live
        setCashfree(cf);
      };
      loadCashfree();
    }
  }, []);
  useEffect(() => {
    if (cashfree !== null) {
      mountingCardNumber();
      mountingCardHolder();
      mountingExpiryDate();
      mountingCvv();
    }
  }, [cashfree, cardType]);

  const getCardType = (number) => {
    const cardNumber = number.replace(/\D/g, "");
    const patterns = {
      visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
      masterCard: /^5[1-5][0-9]{14}$/,
      ruPay: /^6[0-9]{15}$/,
      amex: /^3[47][0-9]{13}$/,
      maestro: /^(?:5[06789][0-9]{0,}|6[0-9]{0,})[0-9]{12,}$/,
    };

    if (patterns.visa.test(cardNumber)) return "Visa";
    if (patterns.masterCard.test(cardNumber)) return "MasterCard";
    if (patterns.ruPay.test(cardNumber)) return "RuPay";
    return "Unknown Card Type";
  };
  const payamount = async () => {
    if (isEasebuzzSchool === true) {
      axios
        .get(
          `${process.env.REACT_APP_PAYMENT_BACKEND}/easebuzz/encrypted-info?card_number=${cardNumber}&card_holder=${cardHolderName}&card_cvv=${cardCvvNumber}&card_exp=${`${cardExpiryDate.slice(0, 3)}20${cardExpiryDate.slice(3)}`}`
        )
        .then((response) => {
          if (response.data) {
            initiateCard({
              payment_id: easebuzzPaymentId,
              card_number: response.data.card_number,
              card_holder_name: response.data.card_holder,
              card_cvv: response.data.card_cvv,
              card_expiry_date: response.data.card_exp,
              type:
                cardType === "DebitCard"
                  ? "DC"
                  : cardType === "CreditCard"
                    ? "CC"
                    : "",
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error.message);
        });
    }
    if (isEasebuzzSchool === false) {
      cashfree
        .pay({
          paymentMethod: cardComponent,
          paymentSessionId: paymentId,
          redirectTarget: isBlank === "true" ? "_blank" : "_self",

          returnUrl: process.env.REACT_APP_RETURN_URL + collect_request_id,
        })
        .then(function (data) {
          if (data && data?.error) {
            toast.error(data.error.message || "Something went wrong");
          }
        })
        .catch((error) => {
          toast.error(error.message);
        });
    }
  };

  useEffect(() => {
    //
    payRef.current.disabled = true;
    if (
      isEasebuzzSchool === false &&
      isCardCvvReady &&
      isCardExpiryReady &&
      isCardHolderReady &&
      isCardNumberReady
    ) {
      payRef.current.disabled = false;
    }

    if (
      isEasebuzzSchool === true &&
      cardNumber !== "" &&
      cardHolderName !== "" &&
      cardCvvNumber !== "" &&
      cardCvvNumber.length === 3
    ) {
      payRef.current.disabled = false;
    }
    if (cardNumber.length > 15) {
      finalAmountWithMDR(cardType, card_type?.type);
    }
    // if (isCardExpiryReady) {
    //   setIsFlipped(true);
    // } else {
    //   setIsFlipped(false);
    // }
  }, [
    isCardCvvReady,
    isCardExpiryReady,
    isCardHolderReady,
    isCardNumberReady,
    cardNumber,
    cardHolderName,
    cardCvvNumber,
  ]);

  childComponentFunctionRef.current = payamount;
  return (
    <>
      <div className="flex m-4 gap-x-4">
        <div className="flex px-3  items-center w-[110px] h-10 shadow-black-shadow rounded-lg">
          <img src={creditCard} className="w-[39px] h-[29px]" alt="cards" />
          <p className="ml-1 mt-1 space-x-1 font-medium text-[7px] text-[#717171]">
            {cardType === "CreditCard" ? "Credit Card" : "Debit Card"}
          </p>
        </div>
        <div className="flex flex-col">
          <p className=" text-[12px] text-black font-semibold ">
            Pay with {cardType === "CreditCard" ? "Credit Card" : "Debit Card"}{" "}
          </p>
          <p className=" text-[9px] font-normal text-[#717171]">
            Enter Card details
          </p>
        </div>
        <p
          onClick={() => setOpenWindow(false)}
          className="text-[9px] underline text-[#505E8F] ml-auto cursor-pointer"
        >
          Close
        </p>
      </div>
      {/*<div className="px-4 flex mb-3 justify-end items-center gap-2">
        <h6 className="text-xs">Flip to enter CVV</h6>
        <span>
          <i
            onClick={() => {
              setIsFlipped(!isFlipped);
            }}
            className="fa-solid text-xl cursor-pointer fa-repeat ml-auto"
          >
            {" "}
          </i>
        </span>
          </div>*/}
      <div
        className={`credit-card w-full mt-4 h-52 ${isFlipped ? "flipped" : ""}`}
      >
        <div className="front px-4 text-white">
          {isEasebuzzSchool === false && (
            <div
              className={
                "flex h-[200px] justify-between  flex-col bg-gradient-to-r from-neutral-600 to-zinc-900 p-[20px] rounded-xl"
              }
            >
              <div className="w-full flex gap-x-2 items-center">
                <img src={chip} className="w-10" alt="cardType" />
                <img src={connectIcon} className="w-3" alt="cardType" />
              </div>
              <div id="cardNumber"></div>
              <div className="flex gap-x-10 items-center justify-sapcebetween">
                <div id="cardHolder"></div>
                <div className="shrink-0" id="expiry"></div>
              </div>

              <div className="flex justify-center items-center relative">
                <div className="max-w-fit">
                  <p className="text-[12px] text-[#717171]">CVV</p>
                </div>
                <div id="cvv" className="w-10"></div>
              </div>
            </div>
          )}
          {isEasebuzzSchool === true && (
            <div className="h-60 rounded-lg bg-gradient-to-r from-neutral-600 to-zinc-900 p-[20px] text-white shadow-lg">
              <div className="flex w-full items-center gap-x-2">
                <img
                  src="https://pg.edviron.com/static/media/Chip.fa79a9f20a676e2745b94773b7c0caeb.svg"
                  className=""
                  alt="cardType"
                />
                <img
                  src="https://pg.edviron.com/static/media/Conection%20Icon.f7fcdf1f04fe3f752f9fea9126e4fa13.svg"
                  className=""
                  alt="cardType"
                />
              </div>

              <div className="mb-4 border-b flex  justify-between items-center">
                <input
                  type="text"
                  value={cardNumber}
                  onChange={(e) => {
                    let input = e.target.value.replace(/\D/g, "");
                    let formatted = "";
                    for (let i = 0; i < input.length; i++) {
                      if (i > 0 && i % 4 === 0) {
                        formatted += " ";
                      }
                      formatted += input[i];
                    }
                    formatted = formatted.slice(0, 19);
                    setCardNumber(formatted);
                    const type = getCardType(input);

                    set_card_type({
                      type: type,
                      img:
                        type === "RuPay"
                          ? rupay
                          : type === "Visa"
                            ? visa
                            : type === "MasterCard"
                              ? master
                              : null,
                    });
                  }}
                  id="card-number"
                  pattern="[0-9]*"
                  maxLength="19"
                  placeholder="enter card number"
                  className="w-full  bg-transparent py-1.5 focus:outline-none "
                />

                {card_type?.img && (
                  <img
                    className="h-5"
                    src={card_type?.img}
                    alt={card_type?.type}
                  />
                )}
              </div>
              <div className="mb-4 flex items-center justify-between">
                <div className="mr-2 w-full">
                  <input
                    type="text"
                    id="card-holder"
                    onChange={(e) => {
                      setCardHolderName(e.target.value);
                    }}
                    placeholder="enter card holder name"
                    className="w-full border-b bg-transparent py-1.5 focus:outline-none "
                  />
                </div>
                <div className="ml-2 w-1/3">
                  <input
                    type="text"
                    id="expiry-date"
                    placeholder="MM/YY"
                    value={cardExpiryDate}
                    onChange={(e) => {
                      let input = e.target.value.replace(/\D/g, "");
                      let formatted = "";
                      for (let i = 0; i < input.length; i++) {
                        if (input.length === 2 && Number(input) > 12) {
                          input = "12";
                        }
                        if (i > 0 && i % 2 === 0) {
                          formatted += "/";
                        }
                        formatted += input[i];
                      }
                      formatted = formatted.slice(0, 6);
                      setCardExpiryDate(formatted);
                    }}
                    className={`w-full border-b bg-transparent py-1.5 focus:outline-none 
                  ${
                    cardExpiryDate.length > 2 &&
                    cardExpiryDate.slice(3) <
                      new Date().getFullYear().toString().slice(2)
                      ? " border-red-500 text-red-500"
                      : " border-white text-white"
                  }
                    
                `}
                    inputmode="numeric"
                    pattern="[0-9]*"
                    maxLength="5"
                  />
                </div>
              </div>
              <div className="mb-4 flex items-center justify-center space-x-3">
                <p className="text-[12px] text-[#717171]">CVV</p>
                <input
                  value={cardCvvNumber}
                  onChange={(e) => {
                    let input = e.target.value.replace(/\D/g, "");
                    setCardCvvNumber(input);
                  }}
                  type="password"
                  id="numberInput"
                  maxLength="3"
                  placeholder="•••"
                  className="w-1/3 bg-transparent py-1.5 focus:outline-none"
                  inputmode="numeric"
                  pattern="[0-9]*"
                />
              </div>
            </div>
          )}
        </div>
        {/*<div className="back px-4 relative">
      <p className=" absolute transform text-[4px] text-white font-normal right-0 bottom-28 -rotate-90">
        CIA 000012 CSM-1234--4321
      </p>
      <div
        className={
          " h-full bg-gradient-to-r from-neutral-600 to-zinc-900 pt-4 rounded-xl"
        }
      >
        <div className="h-10 bg-black">dsf</div>
        <div className="text-[6px] text-white font-normal ml-8 mt-6 max-w-[17rem] flex justify-between">
          <span>Authorized Signature</span>
          <span>Not Valid Unless Signed</span>
        </div>
        <div className="flex bg-[#E5E5E5] justify-between h-10 ml-8 max-w-[17rem]">
          <div id="cvv" className="text-left grid content-center"></div>
        </div>
        <div className=" max-w-[16rem] mt-4">
          <p className="text-[5px] text-justify ml-8 text-white font-normal">
            Lorem Ipsum Indoctum accusamus comprehensam Nullam id dolor id
            nibh ultricies vehicula ut id elit. Donec sed odio dui. Fusce
            dapibus, tellus ac cursus etiam porta sem malesuada magna mollis
            euismod. commodo, Faccibus mollis interdum. Morbi leo risus,
            porta ac, vestibulum at eros.Feugiat accumsan Suspendisse eget
            Duis faucibus tempus pede pede augue pede. Dapibus mollis
            dignissim suscipit porta justo nisl amet Nunc quis semper.
            Indoctum accusamus comprehensam .
          </p>
        </div>
        <div className="mt-6 space-y-3 text-center">
          <p className="text-[5px] text-white font-normal">
            +234089876543, +234803456789, +234089876543, +234089876543,
          </p>
          <p className="text-[5px] text-white font-normal">
            www.bankofruqmania.com
          </p>
        </div>
      </div>
      </div>*/}
      </div>

      {/* <button onClick={payamount}>Pay</button> */}
    </>
  );
}
export default Card;
